export const bannersPromotion = [
    {
        img: '/images/home/banner-B1.png',
        desc: {
            texts: [
                {
                    text: 'Entérate también de toda nuestra oferta educativa en cursos, bachillerato, licenciaturas y maestrías 100% en línea.',
                    style: {
                        variant: 'h3',
                        color: 'orange-300'
                    },
                }
            ]
        },
        btn1: {
            title: 'Conoce más',
            link: ''
        },
        btn2: {
            title: 'Para Empresas',
            link: 'https://b2b.talisis.com'
        }
    },
    {
        img: '/images/home/banner-B2.png',
        imgSecondary1: '/images/home/todo-talisis.svg',
        imgSecondary2: '/images/home/a-traves-de.svg',
        desc: {
            texts: [
                {
                    text: 'Estudia Bachillerato, Licenciatura o Maestría 100% online a tu propio ritmo con validez ante la SEP.',
                    style: {
                        variant: 'h3',
                        color: 'orange-300'
                    },
                }
            ]
        },
        btn1: {
            title: 'Regístrate aquí',
            link: ''
        },
        btn2: {
            title: '¿Qué es Talisis?',
            link: 'https://quienessomos.talisis.com'
        },
        startDate: '2025-04-28',
        endDate: '2025-05-11',
    },
    {
        img: '/images/home/banner-B3.png',
        desc: '¿Quieres retener el talento y fortalecer la lealtad en tu empresa?',
        btn1: {
            title: 'Solicitar Demo',
            link: 'https://b2b.talisis.com'
        },
        btn2: {
            title: 'Ver video',
            link: 'https://youtu.be/vzcH1fRQnEo?si=_bHZ9bVAu8YvoUBc'
        },
        startDate: '2025-04-28',
        endDate: '2025-05-11',
    },
    {
        img: '/images/home/banner-summer-B4.png',
        imgXs: '/images/home/banner-summer-B4-xs.png',
        imgSecondary1: '/images/home/promo-banner-B4.png',
        desc: {
            texts: [
                {
                    text: '15% de descuento en Plazo Anual',
                    style: {
                        variant: 'h2',
                        color: 'blue-300'
                    },
                },
                {
                    text: 'Aprender sí es una bendición. Aprovecha estos días y comienza a tu propio ritmo con nuestros programas 100% en línea: Bachillerato, Licenciatura o Maestría.',
                    style: {
                        variant: 'h3',
                        color: 'white'
                    },
                },
                {
                    text: 'Utiliza el código: div15',
                    style: {
                        variant: 'h2',
                        color: 'orange-300'
                    },
                },
            ],

        },
        downTitleImg: true,
        fullBgImage: true,
        rootBgLarge: true,
        btn1: {
            title: 'Empieza ya',
            link: 'https://www.talisis.com/membresias'
        },
        startDate: '2025-04-13',
        endDate: '2025-04-27',
    },
    {
        img: '/images/home/banner-hotday-B5.webp',
        imgXs: '/images/home/banner-hotday-B5-xs.png',
        imgSecondary1: '/images/home/promo-banner-hotday-B5.gif',
        desc: {
            texts: [
                {
                    text: '30% de descuento en Plazo Anual',
                    style: {
                        variant: 'h2',
                        color: 'blue-300'
                    },
                },
                {
                    text: 'Aprovecha estos días y aprende a tu propio ritmo 100% en línea con Bachillerato, Licenciatura o Maestría.',
                    style: {
                        variant: 'h3',
                        color: 'white'
                    },
                },
                {
                    text: 'Utiliza el código: HOTDAYS',
                    style: {
                        variant: 'h2',
                        color: 'orange-300'
                    },
                },
            ],

        },
        downTitleImg: true,
        imgPrimaryStyle:{
            width: '100%',
        },
        btn1: {
            title: 'Empieza ya',
            link: 'https://www.talisis.com/membresias',
            color: 'dark-black-500'
        },
        startDate: '2025-05-12',
        endDate: '2025-06-07',
    },
    {
        img: '/images/home/banner-orgullo-B6.png',
        imgXs: '/images/home/banner-orgullo-B6-xs.png',
        imgSecondary1: '/images/home/promo-banner-orgullo-B6.png',
        desc: {
            texts: [
                {
                    text: 'Celebra tu identidad, tu camino y tu crecimiento.',
                    style: {
                        variant: 'h3',
                        color: 'magenta-500'
                    },
                },
                {
                    text: 'Tu aprendizaje también es un acto de orgullo. Aprende a tu propio ritmo.',
                    style: {
                        variant: 'subtitle1',
                        color: 'dark-black-500'
                    },
                },
                {
                    text: 'Utiliza el código: PRIDE20',
                    style: {
                        variant: 'h2',
                        color: 'electric-blue-300'
                    },
                },
                {
                    text: '20% de descuento en plazo semestral y anual',
                    style: {
                        variant: 'subtitle2',
                        color: 'electric-blue-300'
                    },
                },
            ],

        },
        downTitleImg: true,
        imgPrimaryStyle:{
            width: '100%',
        },
        blockImgSecondary:true,
        responsiveContainerStyle:{
            paddingTop: 20,
        },
        btn1: {
            title: 'Empieza ya',
            link: 'https://www.talisis.com/membresias',
            color: 'dark-black-500'
        },
        startDate: '2025-06-09',
        endDate: '2025-06-30',
    },
    {
        img: '/images/home/banner-summer-break-B7.webp',
        imgXs: '/images/home/banner-summer-break-B7-xs.webp',
        imgSecondary1: '/images/home/promo-summer-break-B7.png',
        desc: {
            texts: [
                {
                    text: 'Ten un verano sin cruda académica y avanza más que los demás.',
                    style: {
                        variant: 'h3',
                        color: 'white'
                    },
                },
                {
                    text: 'Aprovecha que todos están descansando para obtener más certificados y asegurar un mejor futuro.',
                    style: {
                        variant: 'subtitle1',
                        color: 'dark-black-500'
                    },
                },
                {
                    text: 'Utiliza el código: SUMMER10',
                    style: {
                        variant: 'h2',
                        color: 'electric-blue-300'
                    },
                },
                {
                    text: '10% de descuento en plazo semestral y anual',
                    style: {
                        variant: 'subtitle2',
                        color: 'electric-blue-300'
                    },
                },
            ],

        },
        downTitleImg: true,
        imgPrimaryStyle:{
            width: '100%',
        },
        blockImgSecondary:true,
        responsiveContainerStyle:{
            paddingTop: 20,
        },
        btn1: {
            title: 'Empieza ya',
            link: 'https://www.talisis.com/membresias',
            color: 'electric-blue-300'
        },
        startDate: '2025-07-07',
        endDate: '2025-07-31',
    },
    {
        isVideo: true,
        img: '/videos/banner-backSchool-B8.png',
        imgXs: '/videos/banner-backSchool-B8-xs.png',
        video: '/videos/banner-backSchool-B8.mp4',
        videoXs: '/videos/banner-backSchool-B8-xs.mp4',
        // imgSecondary1: '/images/home/promo-backSchool-B8.png',
        desc: {
            texts: [
                {
                    text: 'Aprovecha.',
                    style: {
                        variant: 'h3',
                        color: 'orange-300'
                    },
                },
                {
                    text: '20% de descuento en plazo anual',
                    style: {
                        variant: 'h2',
                        color: 'white'
                    },
                },
                // {
                //     text: 'Utiliza el código: SUMMER10',
                //     style: {
                //         variant: 'h2',
                //         color: 'electric-blue-300'
                //     },
                // },
                // {
                //     text: '10% de descuento en plazo semestral y anual',
                //     style: {
                //         variant: 'subtitle2',
                //         color: 'electric-blue-300'
                //     },
                // },
            ],

        },
        downTitleImg: true,
        imgPrimaryStyle:{
            width: '100%',
        },
        blockImgSecondary:true,
        responsiveContainerStyle:{
            paddingTop: 20,
        },
        btn1: {
            title: 'Empieza ya',
            link: 'https://www.talisis.com/membresias',
            color: 'electric-blue-300'
        },
        startDate: '2025-08-06',
        endDate: '2025-09-30',
    },
]
